import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';
import OurWork from './pages/OurWork';
import ITTraining from './pages/ITTraining';
import ProgrammingCourses from './pages/it-training/ProgrammingCourses';
import NonProgrammingCourses from './pages/it-training/NonProgrammingCourses';
import SpecialTraining from './pages/it-training/SpecialTraining';
import ITBlog from './pages/it-training/ITBlog';
import ITContact from './pages/it-training/ITContact';
import CourseDetail from './pages/it-training/CourseDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import AiChatWidget from './components/AiChatWidget';

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isITSection = location.pathname.startsWith('/it-training');

  // IT Training section has its own dedicated header + footer — skip the main ones
  if (isITSection) {
    return (
      <div className="app-shell">
        <Routes>
          <Route path="/it-training" element={<ITTraining />} />
          <Route path="/it-training/programming" element={<ProgrammingCourses />} />
          <Route path="/it-training/non-programming" element={<NonProgrammingCourses />} />
          <Route path="/it-training/special" element={<SpecialTraining />} />
          <Route path="/it-training/blog" element={<ITBlog />} />
          <Route path="/it-training/contact" element={<ITContact />} />
          <Route path="/it-training/course/:slug" element={<CourseDetail />} />
        </Routes>
        <AiChatWidget />
      </div>
    );
  }

  return (
    <div className={isHomePage ? 'app-shell app-shell-home' : 'app-shell'}>
      <Header />
      <main className={isHomePage ? 'page-shell page-shell-home' : 'page-shell'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      {!isHomePage && <Footer />}
      <AiChatWidget />
    </div>
  );
}

export default App;
